var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vaillant"},[_c('AuthorizedService',{attrs:{"logo":"brotje-big.png"}}),_c('Services'),_c('Recipients'),_c('ContactForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }